import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderSlot as _renderSlot, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx, unref as _unref, Transition as _Transition, Teleport as _Teleport, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["tabindex", "onKeydown"]
const _hoisted_2 = {
  key: 0,
  class: "app-select__floating-label-required"
}
const _hoisted_3 = {
  key: 0,
  class: "app-select__single-value"
}
const _hoisted_4 = {
  key: 1,
  class: "app-select__placeholder"
}
const _hoisted_5 = { class: "app-select__first-value" }
const _hoisted_6 = {
  key: 0,
  class: "app-select__additional-count"
}
const _hoisted_7 = {
  key: 1,
  class: "app-select__placeholder"
}
const _hoisted_8 = {
  key: 0,
  class: "app-select__first-value"
}
const _hoisted_9 = {
  key: 1,
  class: "app-select__placeholder"
}
const _hoisted_10 = {
  key: 0,
  class: "app-select__single-value"
}
const _hoisted_11 = {
  key: 1,
  class: "app-select__placeholder"
}
const _hoisted_12 = ["placeholder", "onKeydown"]
const _hoisted_13 = ["onKeydown"]
const _hoisted_14 = {
  key: 0,
  class: "app-select__search"
}
const _hoisted_15 = { class: "app-select__controls-left" }
const _hoisted_16 = { class: "app-select__controls-text" }
const _hoisted_17 = { class: "app-select__controls-right" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 1,
  class: "app-select__divider"
}
const _hoisted_20 = { class: "app-select__options-container" }
const _hoisted_21 = { class: "app-select__options" }
const _hoisted_22 = {
  key: 0,
  class: "app-select__option app-select__option--select-all"
}
const _hoisted_23 = {
  class: "app-select__group-title",
  style: { fontWeight: '400' }
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "app-select__option-content" }
const _hoisted_26 = { class: "app-select__option-name" }
const _hoisted_27 = { class: "app-select__option-description" }
const _hoisted_28 = {
  key: 1,
  class: "app-select__option-content"
}
const _hoisted_29 = { class: "app-select__option-name" }
const _hoisted_30 = { class: "app-select__option-description" }
const _hoisted_31 = {
  key: 0,
  class: "app-select__group"
}
const _hoisted_32 = ["onClick", "onMouseenter"]
const _hoisted_33 = { class: "app-select__group-label" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "app-select__group-count" }
const _hoisted_36 = {
  key: 0,
  class: "app-select__group-children"
}
const _hoisted_37 = ["onClick", "onMouseenter"]
const _hoisted_38 = { class: "app-select__option-content" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "app-select__option-description" }
const _hoisted_41 = {
  key: 1,
  class: "app-select__option-content"
}
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "app-select__option-description" }
const _hoisted_44 = {
  key: 2,
  class: "app-select__option-append"
}
const _hoisted_45 = ["onClick", "onMouseenter"]
const _hoisted_46 = { class: "app-select__option-content" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "app-select__option-description" }
const _hoisted_49 = {
  key: 1,
  class: "app-select__option-content"
}
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = { class: "app-select__option-description" }
const _hoisted_52 = {
  key: 2,
  class: "app-select__option-append"
}
const _hoisted_53 = {
  key: 1,
  class: "app-select__empty"
}

import {
	ref,
	computed,
	watch,
	nextTick,
	onUnmounted,
	useSlots
} from 'vue'
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { escapeHtml, highlightSearchText } from "@/utils/textHelpers";
import { i18n, tp } from "@/i18n";

export interface SelectItem {
	id: string | number
	label: string
	type?: 'item' | 'group'
	disabled?: boolean
	[key: string]: any
}

export interface SelectGroup extends SelectItem {
	type: 'group'
	children: SelectItem[]
	selectable?: boolean
}

export type SelectOption = SelectItem | SelectGroup
export type SelectModelValue = string | number | (string | number)[] | null

type Props = {
	modelValue?: SelectModelValue
	items?: SelectOption[]
	// Строки, закреплённые над основным списком (например текущий пользователь)
	pinnedItems?: SelectOption[]
	multiple?: boolean
	dropdownLabel?: string
	placeholder?: string
	disabled?: boolean
	showSelectAll?: boolean
	valueKey?: string
	labelKey?: string
	displayKey?: string
	descriptionKey?: string
	// Ключ i18n со склонениями для сводки мультиселекта, например job_workers_count
	selectedCountKey?: string
	searchable?: boolean
	showSearchButton?: boolean
	searchPlaceholder?: string
	closeOnSelect?: boolean
	clearable?: boolean,
	minDropdownWidth?: string | number
	dropdownHeight?: string | number
	maxDropdownHeight?: string | number
	customTriggerStyle?: any;
	customSearchStyle?: any;
	dropdownClass?: string;
	ownerChoise?: boolean
	showDropdownClose?: boolean
	showDivider?: boolean
	disabledIcon?: string
	dropdownCloseWidth?: string
	floatingLabel?: boolean
	required?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSelect',
  props: {
    modelValue: { default: null },
    items: { default: () => [] },
    pinnedItems: { default: () => [] },
    multiple: { type: Boolean, default: false },
    dropdownLabel: {},
    placeholder: { default: '' },
    disabled: { type: Boolean, default: false },
    showSelectAll: { type: Boolean, default: false },
    valueKey: { default: 'id' },
    labelKey: { default: 'label' },
    displayKey: { default: undefined },
    descriptionKey: { default: undefined },
    selectedCountKey: { default: undefined },
    searchable: { type: Boolean, default: false },
    showSearchButton: { type: Boolean, default: true },
    searchPlaceholder: { default: '' },
    closeOnSelect: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    minDropdownWidth: {},
    dropdownHeight: { default: undefined },
    maxDropdownHeight: { default: 400 },
    customTriggerStyle: {},
    customSearchStyle: {},
    dropdownClass: {},
    ownerChoise: { type: Boolean },
    showDropdownClose: { type: Boolean, default: false },
    showDivider: { type: Boolean, default: false },
    disabledIcon: { default: '' },
    dropdownCloseWidth: { default: '20px' },
    floatingLabel: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "select", "open", "close", "search"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const isOpen = ref(false)
const isFocused = ref(false)
const isSearchActive = ref(false)
const focusedValue = ref<string | number | null>(null)

const hoveredOptionId = ref<string | number | null>(null)
const searchQuery = ref('')
const triggerRef = ref<HTMLElement | null>(null)
const dropdownRef = ref<HTMLElement | null>(null)
const $searchInputRef = ref<typeof AppInput | null>(null)
const editInputRef = ref<HTMLInputElement | null>(null)
const showOnlySelected = ref(false)
const dropdownStyles = ref({})

const slots = useSlots()

// Проверка наличия групп
const hasGroups = computed(() => {
	return props.items.some(item => item.type === 'group')
})

// Дропдаун рисует наш список, а не кастомное содержимое через слот
const hasDefaultDropdown = computed(() => !slots.dropdown)

// «Стандартный» мультиселект: без кастомного содержимого дропдауна и без статичной подписи триггера
const isStandardMultiple = computed(() =>
	props.multiple && hasDefaultDropdown.value && !props.dropdownLabel
)

const isInlineSearch = computed(() =>
	props.searchable && !props.ownerChoise && (!props.multiple || isStandardMultiple.value)
)

// Поисковый инпут перекрывает выбранные значения в поле
const isSearchFieldActive = computed(() => {
	if (!isInlineSearch.value || !isOpen.value) {
		return false
	}

	if (!isStandardMultiple.value) {
		return true
	}
	return isSearchActive.value
})

const showSearchToggle = computed(() =>
	isStandardMultiple.value && isInlineSearch.value && isOpen.value
)

// Получение всех выбираемых элементов
const selectableItems = computed(() => {
	const result: { id: string | number; label: string }[] = []

	props.items.forEach(item => {
		if (item.type === 'group') {
			item.children.forEach(child => {
				if (!child.disabled) {
					result.push({ id: child.id, label: child.label })
				}
			})
		} else {
			if (!item.disabled) {
				result.push({ id: item.id, label: item.label })
			}
		}
	})
	return result
})

// Поиск оригинальной группы для получения полного количества детей
const findOriginalGroup = (groupId: string | number) => {
	return props.items.find(item =>
		item.type === 'group' && item.id === groupId
	) as SelectGroup | undefined
}

// Совпадение строки с активным поисковым запросом. Пустой запрос ничего не «находит» —
// на этом держится режим «Показать выбранных» без фильтрации
const matchesSearch = (label: string): boolean => {
	if (!searchQuery.value) {
		return false
	}

	return label.toLowerCase().includes(searchQuery.value.toLowerCase())
}

// Фильтрация при поиске
const processedItems = computed((): SelectOption[] => {
	if (!props.searchable || !searchQuery.value) {
		return props.items.map(item => {
			if (item.type === 'group') {
				return {
					...item,
					showChildren: true
				}
			}
			return item
		})
	}

	return props.items.reduce<SelectOption[]>((acc, item) => {
		if (item.type === 'group') {
			const groupMatches = item.label.toLowerCase().includes(searchQuery.value.toLowerCase())

			if (groupMatches) {
				acc.push({
					...item,
					showChildren: true
				})
			} else {
				const matchingChildren = item.children.filter(child =>
					child.label.toLowerCase().includes(searchQuery.value.toLowerCase())
				)
				if (matchingChildren.length > 0) {
					acc.push({
						...item,
						children: matchingChildren,
						showChildren: true
					})
				}
			}
		} else {
			if (item.label.toLowerCase().includes(searchQuery.value.toLowerCase())) {
				acc.push(item)
			}
		}

		return acc
	}, [])
})

// Выбранные значения
const selectedValue = computed(() => {
	if (props.multiple) return null
	return props.modelValue
})

const selectedValues = computed((): (string | number)[] => {
	if (!props.multiple) return []
	return Array.isArray(props.modelValue) ? props.modelValue : []
})

const isSelectedOnlyMode = computed(() => showOnlySelected.value && props.multiple)

// «Показать выбранных» показывает всех выбранных независимо от поиска плюс всё, что подходит
// под текущий запрос, поэтому считаем от исходного списка, а не от уже отфильтрованного
const selectedOrMatchedItems = computed((): SelectOption[] => {
	return props.items.reduce<SelectOption[]>((acc, item) => {
		if (item.type === 'group') {
			const children = matchesSearch(item.label)
				? item.children
				: item.children.filter(child =>
					selectedValues.value.includes(child.id) || matchesSearch(child.label)
				)

			// Группы без участников выбираются собственным id — их тоже нельзя терять
			if (children.length > 0 || selectedValues.value.includes(item.id) || matchesSearch(item.label)) {
				acc.push({
					...item,
					children,
					showChildren: true
				})
			}
		} else {
			if (selectedValues.value.includes(item.id) || matchesSearch(item.label)) {
				acc.push(item)
			}
		}

		return acc
	}, [])
})

// Фильтрация по выбранным элементам
const filteredItemsWithSelected = computed((): SelectOption[] => {
	if (!isSelectedOnlyMode.value) {
		return processedItems.value
	}

	return selectedOrMatchedItems.value
})

// Плоский список того, что реально отрисовано — по нему ходят стрелки и Enter
const filteredSelectableItems = computed(() => {
	const result: { id: string | number; label: string }[] = []

	filteredItemsWithSelected.value.forEach(item => {
		if (item.type === 'group') {
			if (!item.showChildren) {
				return
			}

			item.children.forEach((child: SelectItem) => {
				if (!child.disabled) {
					result.push({ id: child.id, label: child.label })
				}
			})
		} else {
			if (!item.disabled) {
				result.push({ id: item.id, label: item.label })
			}
		}
	})

	return result
})

// Закреплённые строки над списком
const visiblePinnedItems = computed((): SelectOption[] => {
	if (!props.pinnedItems.length) {
		return []
	}

	if (isSelectedOnlyMode.value) {
		return props.pinnedItems.filter(item =>
			selectedValues.value.includes(item.id) || matchesSearch(item.label)
		)
	}

	if (searchQuery.value) {
		return []
	}

	return props.pinnedItems
})

// Количество выбранных элементов
const selectedValuesLength = computed(() => {
	if (props.multiple) {
		return selectedValues.value.length
	}
	return selectedValue.value != null ? 1 : 0
})

const showClearIcon = computed(() => {
	if (!isStandardMultiple.value) {
		return props.clearable && selectedValuesLength.value > 0
	}

	return isSearchFieldActive.value && searchQuery.value.length > 0
})

const editContainerStyle = computed(() =>
	isStandardMultiple.value && isOpen.value ? { right: '80px' } : {}
)

const resolvedPlaceholder = computed(() =>
	props.placeholder || String(i18n.global.t('ui_select_placeholder'))
)
const resolvedSearchPlaceholder = computed(() =>
	props.searchPlaceholder || String(i18n.global.t('search_label'))
)
const triggerPlaceholder = computed(() => (props.floatingLabel ? '' : resolvedPlaceholder.value))

const isLabelActive = computed(() => isOpen.value || isFocused.value || selectedValuesLength.value > 0)

// Состояние группы
const getGroupState = (group: SelectGroup) => {
	const childIds = group.children.map(child => child.id)
	const hasDisabledChildren = group.children.some(child => child.disabled)

	return {
		isSelected: childIds.length > 0 && childIds.every(id => selectedValues.value.includes(id)),
		isDisabled: group.disabled || hasDisabledChildren
	}
}

// В нашем списке группа приходит уже отфильтрованным клоном, поэтому состояние считаем
// по исходному составу
const getOwnGroupState = (group: SelectOption) => {
	return getGroupState((findOriginalGroup(group.id) ?? group) as SelectGroup)
}

// Проверка выбран ли элемент
const isSelected = (value: string | number): boolean => {
	if (props.multiple) {
		return selectedValues.value.includes(value)
	}
	return selectedValue.value === value
}

const getDescription = (item: SelectItem): string => {
	if (!props.descriptionKey) {
		return ''
	}

	const value = item[props.descriptionKey]
	return value == null ? '' : String(value)
}

const getDescriptionTooltip = (item: SelectItem): string => escapeHtml(getDescription(item))

// Получение отображаемого текста
const getDisplayValue = (value: string | number): string => {
	const label = findDisplayItem(props.items, value) ?? findDisplayItem(props.pinnedItems, value)
	return label || String(value)
}

const findDisplayItem = (items: SelectOption[], value: string | number): string | undefined => {
	for (const item of items) {
		if (item.type === 'group') {
			if (item.id === value) return item.label
			const found = item.children.find(child => child.id === value)
			if (found) return found.label
		} else {
			if (item.id === value) return item.label
		}
	}
	return undefined
}

// Элементы для отображения в триггере
const selectedDisplayItems = computed(() => {
	return selectedValues.value.map(id => ({
		id,
		label: getDisplayValue(id)
	}))
})

// Сводка по количеству выбранного для триггера стандартного мультиселекта.
// Единственный выбранный элемент показываем полностью
const selectedCountLabel = computed(() => {
	const count = selectedValues.value.length

	if (count === 1) {
		return getDisplayValue(selectedValues.value[0])
	}

	const noun = props.selectedCountKey ? ` ${tp(props.selectedCountKey, count)}` : ''

	return `${String(i18n.global.t('selected_label'))} ${count}${noun}`
})

// Проверка выбраны ли все
const isAllSelected = computed((): boolean => {
	if (!props.multiple) return false
	return selectableItems.value.length > 0 &&
		selectableItems.value.every(item => selectedValues.value.includes(item.id))
})

// Обновление позиции дропдауна
const updateDropdownPosition = () => {
	if (!triggerRef.value || !isOpen.value) return

	const rect = triggerRef.value.getBoundingClientRect()
	const viewportHeight = window.innerHeight
	const spaceBelow = viewportHeight - rect.bottom
	const spaceAbove = rect.top

	// Определяем направление открытия
	let openUp = false
	if (props.dropdownHeight === undefined) {
		// При динамической высоте используем старую логику
		openUp = spaceBelow < 300 && spaceAbove > spaceBelow
	} else {
		// При фиксированной высоте тоже можно определять направление,
		// чтобы дропдаун не выходил за экран по вертикали
		openUp = spaceBelow < (typeof props.dropdownHeight === 'number' ? props.dropdownHeight : parseFloat(props.dropdownHeight)) && spaceAbove > spaceBelow
	}

	// Вычисляем ширину (без изменений)
	let width = `${rect.width}px`
	if (props.minDropdownWidth) {
		const minWidth = typeof props.minDropdownWidth === 'number'
			? `${props.minDropdownWidth}px`
			: props.minDropdownWidth
		width = `max(${minWidth}, ${rect.width}px)`
	}

	// Базовые стили позиционирования
	const styles: any = {
		position: 'fixed',
		top: openUp ? 'auto' : `${rect.bottom + 4}px`,
		bottom: openUp ? `${viewportHeight - rect.top + 4}px` : 'auto',
		left: `${rect.left}px`,
		width: width,
		minWidth: props.minDropdownWidth ? `${rect.width}px` : 'auto',
		zIndex: 10001
	}

	if (props.dropdownHeight !== undefined) {
		// Фиксированная высота
		const heightValue = typeof props.dropdownHeight === 'number'
			? `${props.dropdownHeight}px`
			: props.dropdownHeight
		styles.height = heightValue
		// Убираем maxHeight, чтобы не конфликтовать
		styles.maxHeight = 'none'
	} else {
		// Динамическая высота
		const availableHeight = openUp ? spaceAbove - 20 : spaceBelow - 20
		let maxH = Math.max(100, availableHeight)
		if (props.maxDropdownHeight !== undefined) {
			const limit = typeof props.maxDropdownHeight === 'number'
				? props.maxDropdownHeight
				: parseFloat(props.maxDropdownHeight)
			if (!Number.isNaN(limit)) {
				maxH = Math.min(maxH, limit)
			}
		}
		styles.maxHeight = `${maxH}px`
	}

	dropdownStyles.value = styles
}

// const minTriggerHeight =computed(() => {
// 	const styles: any = {
// 		minHeight:`32px`,
// 	}

// 	if (props.minTriggerHeight !== 32) {
// 		styles.minHeight = `${typeof props.minTriggerHeight === 'number'
// 			? props.minTriggerHeight
// 			: parseFloat(props.minTriggerHeight)}px`
// 	}

// 	return styles;
// });

// Сброс выбора
const resetSelection = (): void => {
	if (!props.multiple) return

	emit('update:modelValue', [])
	emit('select', [])
}

const toggleShowOnlySelected = (value: boolean) => {
	showOnlySelected.value = value
}

// Очистка значения
const handleClear = () => {
	if (props.multiple) {
		emit('update:modelValue', [])
		emit('select', [])
	} else {
		emit('update:modelValue', null)
		emit('select', null)
	}
}

// Возврат каретки в поисковое поле после выбора не мышью: режим поиска гасится только лупой,
// поэтому фокус тоже должен оставаться в инпуте
const restoreSearchFocus = (): void => {
	if (!isStandardMultiple.value || !isSearchFieldActive.value) {
		return
	}

	nextTick(() => editInputRef.value?.focus({ preventScroll: true }))
}

const activateSearch = (): void => {
	isSearchActive.value = true

	nextTick(() => editInputRef.value?.focus())
}

// Клик по лупе переключает режим: активный поиск выключаем и сбрасываем фильтр,
// чтобы в списке снова были все элементы
const toggleSearch = (): void => {
	if (isSearchFieldActive.value) {
		searchQuery.value = ''
		isSearchActive.value = false
		editInputRef.value?.blur()
		return
	}

	activateSearch()
}

// Клик по стрелочке: в режиме поиска чистит введённый текст, в остальных селектах — выбор
const handleClearClick = (): void => {
	if (isSearchFieldActive.value) {
		searchQuery.value = ''
		editInputRef.value?.focus()
		return
	}

	handleClear()
}

// Обработка клика по триггеру
const handleTriggerClick = () => {
	if (props.disabled) return

	// У открытого мультиселекта клик по полю ничего не переключает: режим поиска включает
	// и выключает только лупа, а свернуть список можно шевроном, кликом вне селекта или по Esc
	if (isOpen.value && isStandardMultiple.value && isInlineSearch.value) {
		return
	}

	toggleDropdown()
}

// Обработка Enter на триггере
const handleTriggerEnter = (): void => {
	if (props.disabled) return

	if (!isOpen.value) {
		toggleDropdown()
	} else {
		nextTick(() => {
			if (dropdownRef.value) {
				dropdownRef.value.focus()
			}
		})
	}
}

// Обработка Enter в поиске
const handleSearchEnter = () => {
	if (!isOpen.value) return;

	if (focusedValue.value) {
		const isInList = filteredSelectableItems.value.some(
			item => item.id === focusedValue.value
		);

		if (isInList) {
			handleSelect(focusedValue.value);
			// В мультивыборе Enter только отмечает элемент — дропдаун остаётся открытым
			if (!props.multiple) {
				closeDropdown();
			}
			return;
		}
	}

	const firstItem = filteredSelectableItems.value[0];
	if (firstItem) {
		handleSelect(firstItem.id);
		if (!props.multiple) {
			closeDropdown();
		}
	}
};

// Обработка Enter в дропдауне
const handleDropdownEnter = (): void => {
	if (!isOpen.value || !focusedValue.value) return

	const isInFilteredList = filteredSelectableItems.value.some(
		item => item.id === focusedValue.value
	)

	if (!isInFilteredList) return

	const item = findEnterPressedItem(filteredItemsWithSelected.value)
	if (item && !item.disabled) {
		if (item.type !== 'group') {
			handleSelect(item.id)
		}
	}
}

const findEnterPressedItem = (items: SelectOption[]): SelectItem | undefined => {
	for (const item of items) {
		if (item.type === 'group') {
			if (item.id === focusedValue.value) {
				if (props.multiple && (item as SelectGroup).selectable) {
					toggleGroupSelection(item as SelectGroup)
					return undefined
				}
				return undefined
			}
			const found = item.children.find(child => child.id === focusedValue.value)
			if (found) return found
		} else {
			if (item.id === focusedValue.value) return item
		}
	}
	return undefined
}

// Обработка клавиш на триггере
const handleTriggerKeyDown = (event: KeyboardEvent): void => {
	if (!isOpen.value) {
		if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
			event.preventDefault()
			toggleDropdown()
		}
	}
}

// Обработка клавиш в дропдауне
const handleDropdownKeyDown = (event: KeyboardEvent): void => {
	if (!isOpen.value || !filteredSelectableItems.value.length) return

	const currentIndex = filteredSelectableItems.value.findIndex(
		item => item.id === focusedValue.value
	)

	let newIndex: number

	switch (event.key) {
		case 'ArrowDown':
			event.preventDefault()
			newIndex = currentIndex < filteredSelectableItems.value.length - 1 ? currentIndex + 1 : 0
			focusedValue.value = filteredSelectableItems.value[newIndex].id
			nextTick(() => scrollToFocused())
			break

		case 'ArrowUp':
			event.preventDefault()
			newIndex = currentIndex > 0 ? currentIndex - 1 : filteredSelectableItems.value.length - 1
			focusedValue.value = filteredSelectableItems.value[newIndex].id
			nextTick(() => scrollToFocused())
			break
	}
}

// Обработка выбора элемента
const handleSelect = (value: string | number, event?: Event): void => {
	if (props.disabled) return

	if (event) {
		event.stopPropagation()
	}

	let newValue: SelectModelValue

	if (props.multiple) {
		const values = [...selectedValues.value]
		const index = values.indexOf(value)

		if (index === -1) {
			values.push(value)
		} else {
			values.splice(index, 1)
		}

		newValue = values
	} else {
		newValue = value
		if (props.closeOnSelect) {
			setTimeout(() => {
				isOpen.value = false
				emit('close')
			}, 100)
		}
	}

	emit('update:modelValue', newValue)
	emit('select', newValue)

	if (props.searchable && !props.multiple) {
		searchQuery.value = ''
	}

	restoreSearchFocus()
}

// Обработка клика по элементу
const handleItemClick = (item: SelectItem): void => {
	if (item.disabled || item.type === 'group') return

	if (!props.multiple) {
		handleSelect(item.id)
	}
}

// Можно ли выбрать группу целиком (при единичном выборе — нельзя)
const isGroupSelectable = (group: SelectOption): boolean => {
	return props.multiple && group.selectable !== false
}

// Наведение на заголовок группы
const handleGroupHeaderEnter = (group: SelectOption): void => {
	focusedValue.value = isGroupSelectable(group)
		? group.id
		: null
}

// Переключение выбора группы
const toggleGroupSelection = (group: SelectGroup): void => {
	if (!props.multiple || group.selectable === false || group.disabled) return

	const originalGroup = findOriginalGroup(group.id)
	if (!originalGroup) return

	const childIds = originalGroup.children
		.filter(child => !child.disabled)
		.map(child => child.id)

	const state = getGroupState(originalGroup)
	const currentValues = [...selectedValues.value]

	let newValues: (string | number)[]

	if (state.isSelected) {
		newValues = currentValues.filter(id => !childIds.includes(id))
	} else {
		newValues = [...currentValues]
		childIds.forEach(id => {
			if (!newValues.includes(id)) {
				newValues.push(id)
			}
		})
	}

	emit('update:modelValue', newValues)
	emit('select', newValues)

	restoreSearchFocus()
}

// Выбрать все
const toggleAll = (): void => {
	if (!props.multiple) return

	if (isAllSelected.value) {
		emit('update:modelValue', [])
		emit('select', [])
	} else {
		emit('update:modelValue', selectableItems.value.map(item => item.id))
		emit('select', selectableItems.value.map(item => item.id))
	}
}

// Переключение дропдауна
const toggleDropdown = (): void => {
	if (props.disabled) return

	isOpen.value = !isOpen.value

	if (isOpen.value) {
		emit('open')
		updateDropdownPosition()

		const firstSelectable = filteredSelectableItems.value[0]
		focusedValue.value = firstSelectable?.id || null

		nextTick(() => {
			if (isInlineSearch.value) {
				editInputRef.value?.focus()
			} else if (props.searchable) {
				$searchInputRef.value?.focusInput()
			} else {
				dropdownRef.value?.focus()
			}
		})
	} else {
		emit('close')
		if (props.multiple) {
			searchQuery.value = ''
		}
	}
}

// Закрытие дропдауна
const closeDropdown = (): void => {
	if (isOpen.value) {
		isOpen.value = false
		emit('close')
		if (!props.multiple) {
			searchQuery.value = ''
		}
		// triggerRef.value?.focus()
		triggerRef.value?.blur()
	}
}

// Скролл к фокусированному элементу
const scrollToFocused = (): void => {
	if (!dropdownRef.value || !focusedValue.value) return

	const focusedElement = dropdownRef.value.querySelector(
		'.app-select__option--focused, .app-select__group-header--focused'
	) as HTMLElement

	if (focusedElement) {
		focusedElement.scrollIntoView({
			block: 'center',
			behavior: 'smooth'
		})
	}
}

// Обработка Escape
const handleEscape = (event: KeyboardEvent) => {
	if (event.key === 'Escape') {
		event.preventDefault()
		event.stopPropagation()
		if (isOpen.value) {
			closeDropdown()
		}
	}
}

watch(searchQuery, (value) => {
	emit('search', value)
	const firstSelectable = filteredSelectableItems.value[0]
	focusedValue.value = firstSelectable?.id || null
})

const handleClickOutside = (e: MouseEvent) => {
  const target = e.target as Node
  if (
    triggerRef.value?.contains(target) ||
    dropdownRef.value?.contains(target)
  ) return
  closeDropdown()
}

watch(isOpen, (newVal) => {
	if (newVal) {
		isSearchActive.value = isInlineSearch.value
		// document.addEventListener('mousedown', handleClickOutside)
		document.addEventListener('keydown', handleEscape, { capture: true })
		window.addEventListener('scroll', updateDropdownPosition, true)
		window.addEventListener('resize', updateDropdownPosition)
	} else {
		isSearchActive.value = false
		// document.removeEventListener('mousedown', handleClickOutside)
		document.removeEventListener('keydown', handleEscape, { capture: true })
		window.removeEventListener('scroll', updateDropdownPosition, true)
		window.removeEventListener('resize', updateDropdownPosition)
		showOnlySelected.value = false
		if (props.multiple) {
			searchQuery.value = ''
		}
	}
})

const open = (): void => {
	if (!isOpen.value) {
		toggleDropdown()
	}
}

__expose({ open, close: closeDropdown, focusSearch: activateSearch })

onUnmounted(() => {
	document.removeEventListener('keydown', handleEscape, { capture: true })
	window.removeEventListener('scroll', updateDropdownPosition, true)
	window.removeEventListener('resize', updateDropdownPosition)
})

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-select", {
			'app-select--open': isOpen.value,
			'app-select--disabled': _ctx.disabled,
			'app-select--multiple': _ctx.multiple,
			'app-select--focused': isFocused.value,
			'app-select--has-groups': hasGroups.value,
			'app-select--searchable': isInlineSearch.value,
			'app-select--clearable': _ctx.clearable
		}])
  }, [
    _createElementVNode("div", {
      ref_key: "triggerRef",
      ref: triggerRef,
      class: _normalizeClass({
				'app-select__trigger': true,
				'app-select__trigger--editable': isInlineSearch.value && isOpen.value
			}),
      style: _normalizeStyle(_ctx.customTriggerStyle),
      tabindex: _ctx.disabled ? -1 : 0,
      onClick: handleTriggerClick,
      onKeydown: [
        _withKeys(_withModifiers(handleTriggerEnter, ["prevent"]), ["enter"]),
        _withKeys(closeDropdown, ["esc"]),
        _withKeys(_withModifiers(handleTriggerKeyDown, ["prevent"]), ["down"]),
        _withKeys(_withModifiers(handleTriggerKeyDown, ["prevent"]), ["up"])
      ],
      onFocus: _cache[6] || (_cache[6] = ($event: any) => (isFocused.value = true)),
      onBlur: _cache[7] || (_cache[7] = ($event: any) => (isFocused.value = false))
    }, [
      (_ctx.floatingLabel && resolvedPlaceholder.value)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: _normalizeClass({
					'app-select__floating-label': true,
					active: isLabelActive.value
				})
          }, [
            _createTextVNode(_toDisplayString(resolvedPlaceholder.value) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({
					'app-select__values': true,
					'app-select__values--hidden': isSearchFieldActive.value
				})
      }, [
        (isStandardMultiple.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (selectedValues.value.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(selectedCountLabel.value), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(triggerPlaceholder.value), 1))
            ], 64))
          : (_ctx.multiple && _ctx.dropdownLabel==undefined)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (selectedDisplayItems.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(selectedDisplayItems.value[0].label), 1),
                      (selectedDisplayItems.value.length > 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " +" + _toDisplayString(selectedDisplayItems.value.length - 1), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(triggerPlaceholder.value), 1))
              ], 64))
            : (_ctx.dropdownLabel)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (selectedDisplayItems.value.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.dropdownLabel), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(triggerPlaceholder.value), 1))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (selectedValue.value != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(getDisplayValue(selectedValue.value)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(triggerPlaceholder.value), 1))
                ], 64))
      ], 2),
      (isInlineSearch.value && isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({
					'app-select__edit-container': true,
					'app-select__edit-container--hidden': !isSearchFieldActive.value
				}),
            style: _normalizeStyle(editContainerStyle.value),
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "editInputRef",
              ref: editInputRef,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              class: "app-select__edit-input",
              placeholder: resolvedSearchPlaceholder.value,
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (isSearchActive.value = true)),
              onKeydown: [
                _withKeys(_withModifiers(handleSearchEnter, ["prevent","stop"]), ["enter"]),
                _withKeys(_withModifiers(handleDropdownKeyDown, ["prevent","stop"]), ["down"]),
                _withKeys(_withModifiers(handleDropdownKeyDown, ["prevent","stop"]), ["up"])
              ]
            }, null, 40, _hoisted_12), [
              [_vModelText, searchQuery.value]
            ])
          ], 6))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "app-select__actions",
        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
      }, [
        (showClearIcon.value)
          ? (_openBlock(), _createBlock(AppIcon, {
              key: 0,
              class: "app-select__clear-button",
              name: "arrow-left",
              width: "16px",
              color: "#979797",
              onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
              onClick: _withModifiers(handleClearClick, ["stop"])
            }))
          : _createCommentVNode("", true),
        (showSearchToggle.value)
          ? (_openBlock(), _createBlock(AppIcon, {
              key: 1,
              class: "app-select__search-toggle",
              name: "search-magnify",
              width: "16px",
              color: isSearchActive.value ? '#3F884F' : '#979797',
              "hover-color": isSearchActive.value ? '#3F884F' : '#499259',
              cursor: "pointer",
              onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
              onClick: _withModifiers(toggleSearch, ["stop"])
            }, null, 8, ["color", "hover-color"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "append-icon", { close: closeDropdown }, () => [
          _createVNode(AppIcon, {
            class: "app-select__arrow",
            name: _ctx.disabled && _ctx.disabledIcon ? _ctx.disabledIcon : 'chevron-down',
            width: "16px",
            color: "#979797",
            cursor: "pointer",
            onClick: _withModifiers(toggleDropdown, ["stop"])
          }, null, 8, ["name"])
        ])
      ])
    ], 46, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "select-dropdown" }, {
        default: _withCtx(() => [
          (isOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
						'app-select__dropdown',
						_ctx.dropdownClass,
						{
							'app-select__dropdown--single': !_ctx.multiple,
							'app-select__dropdown--default': hasDefaultDropdown.value
						}
					]),
                style: _normalizeStyle(dropdownStyles.value),
                ref_key: "dropdownRef",
                ref: dropdownRef,
                onKeydown: [
                  _withKeys(_withModifiers(handleDropdownEnter, ["prevent"]), ["enter"]),
                  _withKeys(closeDropdown, ["esc"]),
                  _withKeys(_withModifiers(handleDropdownKeyDown, ["prevent"]), ["down"]),
                  _withKeys(_withModifiers(handleDropdownKeyDown, ["prevent"]), ["up"])
                ]
              }, [
                (_ctx.showDropdownClose)
                  ? (_openBlock(), _createBlock(AppIcon, {
                      key: 0,
                      class: "app-select__dropdown-close",
                      name: "close",
                      width: _ctx.dropdownCloseWidth,
                      color: "#979797",
                      "hover-color": "#3F884F",
                      cursor: "pointer",
                      onClick: _withModifiers(closeDropdown, ["stop"])
                    }, null, 8, ["width"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "app-select__dropdown-header",
                  style: _normalizeStyle(_ctx.customSearchStyle)
                }, [
                  (_ctx.searchable && !isInlineSearch.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(AppInput, {
                          ref_key: "$searchInputRef",
                          ref: $searchInputRef,
                          modelValue: searchQuery.value,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((searchQuery).value = $event)),
                          class: "app-select__search-input",
                          placeholder: resolvedSearchPlaceholder.value,
                          "show-search-button": _ctx.showSearchButton,
                          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["modelValue", "placeholder", "show-search-button"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.multiple)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "app-select__controls",
                        onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                        onMousedown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(AppCheckbox, {
                            value: showOnlySelected.value,
                            onOnInput: toggleShowOnlySelected,
                            onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, ["value"]),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("selector_show_selected")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("button", {
                            class: "app-select__reset-button",
                            onClick: _withModifiers(resetSelection, ["stop"]),
                            disabled: !selectedValues.value.length
                          }, _toDisplayString(_ctx.$t("selector_reset")), 9, _hoisted_18)
                        ])
                      ], 32))
                    : _createCommentVNode("", true)
                ], 4),
                (_ctx.showDivider)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_20, [
                  _renderSlot(_ctx.$slots, "dropdown", {
                    items: filteredItemsWithSelected.value,
                    selected: selectedValues.value,
                    select: handleSelect,
                    getGroupState: getGroupState,
                    close: closeDropdown,
                    search: searchQuery.value
                  }, () => [
                    _createElementVNode("div", _hoisted_21, [
                      (_ctx.multiple && _ctx.showSelectAll && selectableItems.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", {
                              class: "app-select__option-label",
                              onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createVNode(AppCheckbox, {
                                value: isAllSelected.value,
                                onOnInput: toggleAll
                              }, null, 8, ["value"]),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("all_users")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePinnedItems.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `pinned-${String(item.id)}`,
                          class: _normalizeClass({
										'app-select__option': true,
										'app-select__option--pinned': true,
										'app-select__option--selected': isSelected(item.id),
										'app-select__option--disabled': item.disabled
									}),
                          onClick: ($event: any) => (handleItemClick(item))
                        }, [
                          (_ctx.multiple)
                            ? (_openBlock(), _createElementBlock("label", {
                                key: 0,
                                class: "app-select__option-label",
                                onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                                onMousedown: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent"]))
                              }, [
                                _createVNode(AppCheckbox, {
                                  value: isSelected(item.id),
                                  disabled: item.disabled,
                                  onOnChange: ($event: any) => (handleSelect(item.id, $event))
                                }, null, 8, ["value", "disabled", "onOnChange"]),
                                _createElementVNode("span", _hoisted_25, [
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(item.label), 1),
                                  (getDescription(item))
                                    ? (_openBlock(), _createBlock(AppTooltip, {
                                        key: 0,
                                        class: "app-select__option-tooltip",
                                        position: "bottom",
                                        "text-align": "left",
                                        "follow-cursor": "",
                                        offset: 24,
                                        text: getDescriptionTooltip(item)
                                      }, {
                                        activator: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_27, _toDisplayString(getDescription(item)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["text"]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 32))
                            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("span", _hoisted_29, _toDisplayString(item.label), 1),
                                (getDescription(item))
                                  ? (_openBlock(), _createBlock(AppTooltip, {
                                      key: 0,
                                      class: "app-select__option-tooltip",
                                      position: "bottom",
                                      "text-align": "left",
                                      "follow-cursor": "",
                                      offset: 24,
                                      text: getDescriptionTooltip(item)
                                    }, {
                                      activator: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_30, _toDisplayString(getDescription(item)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["text"]))
                                  : _createCommentVNode("", true)
                              ]))
                        ], 10, _hoisted_24))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItemsWithSelected.value, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: String(item.id)
                        }, [
                          (item.type === 'group')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("div", {
                                  class: _normalizeClass({
												'app-select__group-header': true,
												'app-select__group-header--selectable': isGroupSelectable(item),
												'app-select__group-header--static': !isGroupSelectable(item),
												'app-select__group-header--disabled': item.disabled,
												'app-select__group-header--focused': isGroupSelectable(item) && focusedValue.value === item.id
											}),
                                  onClick: _withModifiers(($event: any) => (toggleGroupSelection(item)), ["stop"]),
                                  onMouseenter: ($event: any) => (handleGroupHeaderEnter(item)),
                                  onMousedown: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["prevent"]))
                                }, [
                                  (isGroupSelectable(item))
                                    ? (_openBlock(), _createElementBlock("label", {
                                        key: 0,
                                        class: "app-select__group-checkbox",
                                        onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                                      }, [
                                        _createVNode(AppCheckbox, {
                                          value: getOwnGroupState(item).isSelected,
                                          disabled: item.disabled,
                                          onOnInput: ($event: any) => (toggleGroupSelection(item))
                                        }, null, 8, ["value", "disabled", "onOnInput"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_33, [
                                    _createElementVNode("span", {
                                      class: "app-select__group-title",
                                      innerHTML: _unref(highlightSearchText)(searchQuery.value, item.label)
                                    }, null, 8, _hoisted_34),
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(findOriginalGroup(item.id)?.children.length || item.children.length), 1)
                                  ])
                                ], 42, _hoisted_32),
                                (item.showChildren)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: String(child.id),
                                          class: _normalizeClass({
													'app-select__option': true,
													'app-select__option--child': true,
													'app-select__option--selected': isSelected(child.id),
													'app-select__option--disabled': child.disabled,
													'app-select__option--focused': focusedValue.value === child.id,
													'app-select__option--with-append': !!_ctx.$slots['option-append']
												}),
                                          onClick: ($event: any) => (handleItemClick(child)),
                                          onMouseenter: ($event: any) => {focusedValue.value = child.id; hoveredOptionId.value = child.id},
                                          onMouseleave: _cache[20] || (_cache[20] = ($event: any) => (hoveredOptionId.value = null))
                                        }, [
                                          (_ctx.multiple)
                                            ? (_openBlock(), _createElementBlock("label", {
                                                key: 0,
                                                class: "app-select__option-label",
                                                onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"])),
                                                onMousedown: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["prevent"]))
                                              }, [
                                                _createVNode(AppCheckbox, {
                                                  value: isSelected(child.id),
                                                  disabled: child.disabled,
                                                  onOnChange: ($event: any) => (handleSelect(child.id, $event))
                                                }, null, 8, ["value", "disabled", "onOnChange"]),
                                                _createElementVNode("span", _hoisted_38, [
                                                  _createElementVNode("span", {
                                                    class: "app-select__option-name",
                                                    innerHTML: _unref(highlightSearchText)(searchQuery.value, child.label)
                                                  }, null, 8, _hoisted_39),
                                                  (getDescription(child))
                                                    ? (_openBlock(), _createBlock(AppTooltip, {
                                                        key: 0,
                                                        class: "app-select__option-tooltip",
                                                        position: "bottom",
                                                        "text-align": "left",
                                                        "follow-cursor": "",
                                                        offset: 24,
                                                        text: getDescriptionTooltip(child)
                                                      }, {
                                                        activator: _withCtx(() => [
                                                          _createElementVNode("span", _hoisted_40, _toDisplayString(getDescription(child)), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["text"]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ], 32))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                _createElementVNode("span", {
                                                  class: "app-select__option-name",
                                                  innerHTML: _unref(highlightSearchText)(searchQuery.value, child.label)
                                                }, null, 8, _hoisted_42),
                                                (getDescription(child))
                                                  ? (_openBlock(), _createBlock(AppTooltip, {
                                                      key: 0,
                                                      class: "app-select__option-tooltip",
                                                      position: "bottom",
                                                      "text-align": "left",
                                                      "follow-cursor": "",
                                                      offset: 24,
                                                      text: getDescriptionTooltip(child)
                                                    }, {
                                                      activator: _withCtx(() => [
                                                        _createElementVNode("span", _hoisted_43, _toDisplayString(getDescription(child)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["text"]))
                                                  : _createCommentVNode("", true)
                                              ])),
                                          (_ctx.$slots['option-append'])
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                                _renderSlot(_ctx.$slots, "option-append", {
                                                  item: child,
                                                  hovered: hoveredOptionId.value === child.id
                                                })
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 42, _hoisted_37))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass({
											'app-select__option': true,
											'app-select__option--selected': isSelected(item.id),
											'app-select__option--disabled': item.disabled,
											'app-select__option--focused': focusedValue.value === item.id,
											'app-select__option--with-append': !!_ctx.$slots['option-append']
										}),
                                onClick: ($event: any) => (handleItemClick(item)),
                                onMouseenter: ($event: any) => {focusedValue.value = item.id; hoveredOptionId.value = item.id},
                                onMouseleave: _cache[23] || (_cache[23] = ($event: any) => (hoveredOptionId.value = null))
                              }, [
                                (_ctx.multiple)
                                  ? (_openBlock(), _createElementBlock("label", {
                                      key: 0,
                                      class: "app-select__option-label",
                                      onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"])),
                                      onMousedown: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["prevent"]))
                                    }, [
                                      _createVNode(AppCheckbox, {
                                        value: isSelected(item.id),
                                        disabled: item.disabled,
                                        onOnChange: ($event: any) => (handleSelect(item.id, $event))
                                      }, null, 8, ["value", "disabled", "onOnChange"]),
                                      _createElementVNode("span", _hoisted_46, [
                                        _createElementVNode("span", {
                                          class: "app-select__option-name",
                                          innerHTML: _unref(highlightSearchText)(searchQuery.value, item.label)
                                        }, null, 8, _hoisted_47),
                                        (getDescription(item))
                                          ? (_openBlock(), _createBlock(AppTooltip, {
                                              key: 0,
                                              class: "app-select__option-tooltip",
                                              position: "bottom",
                                              "text-align": "left",
                                              "follow-cursor": "",
                                              offset: 24,
                                              text: getDescriptionTooltip(item)
                                            }, {
                                              activator: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_48, _toDisplayString(getDescription(item)), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["text"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 32))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _createElementVNode("span", {
                                        class: "app-select__option-name",
                                        innerHTML: _unref(highlightSearchText)(searchQuery.value, item.label)
                                      }, null, 8, _hoisted_50),
                                      (getDescription(item))
                                        ? (_openBlock(), _createBlock(AppTooltip, {
                                            key: 0,
                                            class: "app-select__option-tooltip",
                                            position: "bottom",
                                            "text-align": "left",
                                            "follow-cursor": "",
                                            offset: 24,
                                            text: getDescriptionTooltip(item)
                                          }, {
                                            activator: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_51, _toDisplayString(getDescription(item)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["text"]))
                                        : _createCommentVNode("", true)
                                    ])),
                                (_ctx.$slots['option-append'])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                                      _renderSlot(_ctx.$slots, "option-append", {
                                        item: item,
                                        hovered: hoveredOptionId.value === item.id
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_45))
                        ], 64))
                      }), 128)),
                      (!filteredItemsWithSelected.value.length && !visiblePinnedItems.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(isSelectedOnlyMode.value
											? _ctx.$t("selected_users_not_found")
											: searchQuery.value
												? _ctx.$t("matching_users_not_found")
												: _ctx.$t("no_data")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 46, _hoisted_13))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ], 2)), [
    [_directive_click_outside, closeDropdown]
  ])
}
}

})